import { Component, Input, input, output, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

@Component({
	selector: "stages-button-expand-collapse",
	templateUrl: "./button-expand-collapse.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgClass, TranslateModule],
})
export class ButtonExpandCollapseComponent {
	readonly isCollapsed = input<boolean>(false);

	readonly classes = input<string>();

	// TODO: Skipped for migration because:
	//  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
	//  and migrating would break narrowing currently.
	@Input()
	accessibilityTitle?: string;

	readonly pressedButton = output<string>();

	emitPressedButton(): void {
		this.pressedButton.emit("");
	}
}
